angular.module('unica_hotel.hotel_controllers')

.controller('HotelEditController', function(
	$rootScope, $scope, $state, $stateParams,
	HotelEditService
) {

	$scope.pageTitle = 'Modifica Hotel';

	$scope.getHotel( $stateParams.id );

	function updateHotel()
	{
		HotelEditService
			.update( $scope.hotelData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Hotel aggiornato con successo!', '');
					$state.go('app.hospitality.hotel_list');
				} else {
					$rootScope.manageError(data);
				}
			});
	}

	$scope.saveHotel = function () {

		$scope.showLoader();

		if ( !$scope.hotelData.latitude && !$scope.hotelData.longitude ) {
			$scope.geocoder.geocode({
				address: $scope.hotelData.address
			}, function(responses) {
				if (responses && responses.length > 0) {
					$scope.hotelData.latitude  = responses[0].geometry.location.lat();
					$scope.hotelData.longitude = responses[0].geometry.location.lng();

					updateHotel();
				}
			});
		} else {
			updateHotel();
		}

	};

});